import axios from 'axios';

// #region Globals
const URL_CARTOCIUDAD = 'https://www.cartociudad.es/geocoder/api/geocoder';
const TIME_OUT = 10000;
// #endregion

// #region Public functions
/**
 * Fint the candidates
 *
 * @return {Array}
 *
 */
async function getCandidates(text, limit = 10) {
  try {
    const url = `${URL_CARTOCIUDAD}/candidatesJsonp`;

    const {data} = await axios
      .get(url, {
        timeout: TIME_OUT,
        params: {
          q: text,
          limit,
        },
      });
    const newRes = data.replace('callback(', '');
    const candidates = JSON.parse(newRes.slice(0, newRes.length - 1));
    return candidates.filter((candidate) => {
      return candidate.type.toLowerCase() !== 'provincia';
    });
  } catch (err) {
    return catchError(err);
  }
}

/**
 *
 * @return {Object}
 */
async function findById(id, type, address) {
  try {
    const url = `${URL_CARTOCIUDAD}/findJsonp`;

    const {data} = await axios
      .get(url, {
        timeout: TIME_OUT,
        params: {
          q: address,
          id,
          type,
        },
      });
    const newRes = data.replace('callback(', '');
    return JSON.parse(newRes.slice(0, newRes.length - 1));
  } catch (err) {
    return catchError(err);
  }
}

/**
 *
 * @return {Object}
 */
async function findByRefCatastral(ref) {
  try {
    const url = `${URL_CARTOCIUDAD}/findJsonp`;

    const res = await axios
      .get(url, {
        timeout: TIME_OUT,
        params: {
          q: ref,
          id: ref,
          type: 'refcatastral',
        },
      });
    const newRes = res.data.replace('callback(', '');
    return JSON.parse(newRes.slice(0, newRes.length - 1));
  } catch (err) {
    return catchError(err);
  }
}

/**
 *
 * @return {Object}
 */
async function findByCoords(lat, lon) {
  try {
    const url = `${URL_CARTOCIUDAD}/reverseGeocode`;

    const {data} = await axios
      .get(url, {
        timeout: TIME_OUT,
        params: {
          lon,
          lat,
        },
      });
    return data;
  } catch (err) {
    return catchError(err);
  }
}

/**
 *
 * @param {AxiosErrorDataModel} errorModel
 */
function catchError(errorModel) {
  throw new Error(errorModel);
}


// #endregion

export {
  getCandidates,
  findById,
  findByRefCatastral,
  findByCoords,
};
